import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const formState = (state: RootState) => state.form;

const selectForms = createSelector(formState, (state) => state.forms);
const selectFormsLoading = createSelector(
  formState,
  (state) => state.formsLoading,
);
const selectFolders = createSelector(
  formState,
  (state) => state?.folders || [],
);
const selectFoldersLoading = createSelector(
  formState,
  (state) => state.foldersLoading,
);

const selectFolderById = createSelector(
  [formState, (_, folderId: string) => folderId],
  (state, folderId) => state.folders?.find(({ _id }) => _id === folderId),
);
const selectFolderByFormId = createSelector(
  [formState, (_, formId: string) => formId],
  (state, formId) =>
    state.folders?.find((folder) => folder.formsIds?.includes(formId)),
);

const selectActiveTab = createSelector(formState, (state) => state.activeTab);

export const formSliceSelectors = {
  selectForms,
  selectFolders,
  selectFormsLoading,
  selectFoldersLoading,
  selectFolderById,
  selectFolderByFormId,
  selectActiveTab,
};
